import Logger from './Logger.js';
import {
    LoggerStore,
    MetadataStore,
} from './configStores';

function getLogger(context) {
    return new Logger(context);
}

function sendBeacon() {
    LoggerStore.getAll().forEach((logger) => {
        if (logger.sendBeacon) {
            logger.sendBeacon();
        }
    });
}

const config = {
    useConfig: LoggerStore.addLoggersFromConfig,
    addMetadata: MetadataStore.add,
};

export { config };
export { getLogger };
export { sendBeacon };

export default {
    getLogger,
    config,
    sendBeacon,
};
